import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const PAYU: PaymentMethod = {
    id: PAYMENT_METHOD_ID.PayU,
    name: 'payu',
    displayName: 'PayU'
};
